import React from 'react';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/pro-duotone-svg-icons';

function Instructions({ addFile, tab }) {
  return (
    <div>
      <div>
        <div
          className={[
            'border border-dark border-lg rounded-circle d-inline-flex text-dark',
            'd-flex justify-content-center align-items-center font-weight-bold font-large',
          ].join(' ')}
          style={{ height: '3rem', width: '3rem' }}
        >
          3
        </div>
      </div>
      <div className="my-3">
        <div className="font-weight-bold mb-3">
          Drag and drop files here or hit the upload button below.
        </div>

        {addFile}
      </div>
      {
        ['leads', 'leads_reassignment'].includes(tab)
          ? null
          : (
            <div className="font-italic">
              <small>Make sure to use the CSV file from step 2</small>
            </div>
          )
      }
    </div>
  );
}

const CustomDropzone = ({
  dropzoneProps,
  isDragging,
  addFile,
  closeDropzone,
  tab,
}) => (
  <Col
    xs="12"
    md="4"
    className="text-center border border-dashed border-md border-light p-4 bg-lightgray"
  >
    {isDragging && (
      <div
        id="global-dropzone"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...dropzoneProps}
        onMouseEnter={closeDropzone}
      >
        <div className="border-dashed p-6">
          <FontAwesomeIcon icon={faCloudUploadAlt} size="5x" />
          <h1>Drag & Drop Here to Upload</h1>
        </div>
      </div>
    )}
    <Instructions addFile={addFile} tab={tab} />
  </Col>
);

const mapStateToProps = (store) => ({
  tab: store.batch.tab,
  isDragging: store.batch.dragging,
});

const mapDispatchToProps = {
  closeDropzone: () => ({ type: 'CLOSE_DROPZONE' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomDropzone);
